/**
 * @description Hook to manage the expansion of the details of an expense.
 * @param {Expense} expense - The expense to manage the expansion of the details.
 * @param {string} expenseId - The id of the expense to manage the expansion of the details.
 * @param {function} toggleExpenseDetails - The function to toggle the expansion of the details.
 * @param {function} isExpanded - The function to check if the expense is expanded.
 * @returns {UseExpenseDetailsReturn}
 */

import { useState } from "react";
import { Expense } from "@/features/vouchers";

type UseExpenseDetailsReturn = {
  expandedExpense: Expense | null
  toggleExpenseDetails: (expense: Expense) => void
  isExpanded: (expenseId: string) => boolean
};

export const useExpenseDetails = (): UseExpenseDetailsReturn => {
  const [expandedExpense, setExpandedExpense] = useState<Expense | null>(null);

  const toggleExpenseDetails = (expense: Expense) => {
    setExpandedExpense(expandedExpense?.id === expense.id ? null : expense);
  };

  const isExpanded = (expenseId: string) => {
    return expandedExpense?.id === expenseId;
  };

  return {
    expandedExpense,
    toggleExpenseDetails,
    isExpanded,
  };
};
